export default __webpack_public_path__ + "static/media/card-new-tx-illustration.b71437a9.svg";